import { useTranslation } from 'react-i18next';
import { useCounter } from '@hooks/useCounter';

interface StatItemProps {
  value: number;
  suffix?: string;
  label: string;
}

function StatItem({ value, suffix = '', label }: StatItemProps) {
  const { ref, count } = useCounter(value, 2000);

  return (
    <div ref={ref} className="text-center">
      <div className="font-heading font-black text-4xl md:text-5xl text-white mb-2">
        {count}{suffix}
      </div>
      <div className="text-sm uppercase tracking-widest opacity-90">{label}</div>
    </div>
  );
}

export function StatsBar() {
  const { t } = useTranslation();

  const stats = [
    { value: 30, suffix: '+', label: t('stats.yearsService') },
    { value: 2002, suffix: '', label: t('stats.independence') },
    { value: 2015, suffix: '', label: t('stats.primeMinister') },
    { value: 1, suffix: '', label: t('stats.vision') },
  ];

  return (
    <section className="bg-gradient-to-r from-sky-500 to-sky-600 text-white py-16 relative overflow-hidden">
      {/* Top border gradient */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-sky-300 to-sky-100" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <StatItem
              key={stat.label}
              value={stat.value}
              suffix={stat.suffix}
              label={stat.label}
            />
          ))}
        </div>
      </div>
    </section>
  );
}